import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DxBoxModule, DxButtonModule } from 'devextreme-angular';
import { HttpService } from '../../../http.service';
import { ActionType, MerchantStatus } from '../../home/models';
import { FormPopupModule } from '../../../components/library/form-popup/form-popup.component';
import notify from 'devextreme/ui/notify';

@Component({
  standalone: true,
  imports: [
    DxBoxModule,
    DxButtonModule,
    CommonModule,
    FormPopupModule
  ],
  selector: 'app-approve',
  templateUrl: './approve.component.html',
  styleUrl: './approve.component.scss'
})
export class ApproveComponent {
  @Input() merchantId: number = 0;
  @Input() isApprovedMerchantPopupOpened: boolean = false;

  constructor(private httpService: HttpService) {
  }

  onApprovedClick(e: any) {
    this.isApprovedMerchantPopupOpened = true;
  }

  onConfirmApprovedClick(e: any) {
    let model = new MerchantStatus(this.merchantId, ActionType.Approved, "");
    this.httpService.changeMerchantStatus(model).subscribe(res => {
      notify({
        message: 'Merchant is successfully approved!',
        position: {
          my: 'center top',
          at: 'center top',
        },
      }, 'success', 3000);
    });
  }
}
